import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { get2, post2, put2 } from "../axios";
import { formatResponse } from "../utils/helpers";

import { TImageType } from "@/Pages/Auth/Settings/WebsiteSettings/Settings";
import { useEffect } from "react";

const useWebsiteSettingsHook = ({ franchiseId, enabled = false }) => {
  const { t } = useTranslation();

  const websiteSettingsQuery = useQuery({
    queryKey: ["websiteSettings", franchiseId],
    queryFn: () =>
      get2(
        `internal/secure/pos/v1/restaurants/websites/settings/${franchiseId}`
      ),
    // -1 is the "no franchise loaded yet" placeholder; the API answers it with 403
    enabled: enabled && Number(franchiseId) > 0,
    select: (data) => formatResponse(data),
  });

  useEffect(() => {
    if (websiteSettingsQuery.isError) {
      // errorToast();
    }
  }, [websiteSettingsQuery.isError]);

  const postWebsiteSettings = useMutation({
    mutationFn: ({
      data,
      restaurantSiteSettingsID,
    }: {
      data: any;
      restaurantSiteSettingsID: number;
    }) => {
      return put2(
        `internal/secure/pos/v1/restaurants/websites/settings/${franchiseId}/${restaurantSiteSettingsID}`,
        data
      );
    },
    onSuccess: async () => {
      toast.success(t("success.success"));
    },
    onError: async () => {
      // errorToast(); hv
    },
  });

  const postImageToCloudinary = useMutation({
    mutationFn: (type: TImageType) => {
      return post2(
        `/internal/secure/pos/v1/websites/website-media/${type}/${franchiseId}`
      );
    },
  });

  const uploadImageToCloudinary = useMutation({
    mutationFn: ({ url, formData }: { url: string; formData: object }) => {
      return axios.post(url, formData);
    },
  });

  return {
    postImageToCloudinary,
    websiteSettingsData: websiteSettingsQuery?.data?.[0],
    postWebsiteSettings,
    websiteSettingsQuery,
    uploadImageToCloudinary,
  };
};

export default useWebsiteSettingsHook;
